import React from 'react';
import { Stack, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { FinanceDateType } from '@trnsact/trnsact-shared-types';

interface Props {
  value: FinanceDateType;
  onChange: (value: FinanceDateType) => void;
}

const FILTER_LABEL_SX = {
  fontSize: 11,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: 0.4,
  color: 'text.secondary',
  whiteSpace: 'nowrap',
} as const;

const TOGGLE_BTN_SX = {
  px: 1.5,
  py: 0.5,
  fontSize: 11,
  fontWeight: 500,
  textTransform: 'none',
  border: 'none !important',
  borderRadius: '6px !important',
  '&.Mui-selected': { bgcolor: 'background.paper', color: 'text.primary', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' },
} as const;

const TOGGLE_GROUP_SX = {
  bgcolor: 'action.hover',
  borderRadius: '8px',
  p: '3px',
  gap: 0,
  '& .MuiToggleButtonGroup-grouped': { m: 0 },
} as const;

export const DateTypeToggle = ({ value, onChange }: Props) => (
  <Stack direction="row" spacing={0.75} alignItems="center">
    <Typography sx={FILTER_LABEL_SX}>Date type</Typography>
    <ToggleButtonGroup
      exclusive
      value={value}
      onChange={(_, v: FinanceDateType | null) => {
        if (v) onChange(v);
      }}
      sx={TOGGLE_GROUP_SX}
    >
      <Tooltip title="Filter by opportunity creation date">
        <ToggleButton value={FinanceDateType.CreatedOn} sx={TOGGLE_BTN_SX}>
          Created on
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Filter by closed-won date">
        <ToggleButton value={FinanceDateType.ClosedOn} sx={TOGGLE_BTN_SX}>
          Closed on
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  </Stack>
);
